import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { AnnuityLotService } from 'src/app/services/annuity-lot.service';
import { AnnuityPriceService } from 'src/app/services/annuity-price.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import { Category } from 'src/app/models/category';
import { AnnuityPrice } from 'src/app/models/annuity';


export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-annuity-price-dialog',
  templateUrl: './annuity-price-dialog.component.html',
  styleUrls: ['./annuity-price-dialog.component.scss']
})
export class AnnuityPriceDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public priceForm: FormGroup;
  public currentCategory: Category;

  constructor(
    public _annuityLotService: AnnuityLotService,
    public _annuityPriceService: AnnuityPriceService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this._annuityPriceService.currentProductLot = this.data.lot;
    this._annuityPriceService.currentProductPrice = this.data.price;

    this.priceForm = this._annuityPriceService.createPriceForm();
    this._annuityPriceService.loadCategories()
  }

  selectCategory(category) {

    const cat = this._annuityPriceService.arrayCategories.find(function (e) {
      return e.id == category;
    });
    this.currentCategory = cat;

  }


  addPrice() {

    this.priceForm.controls.category_id.setValue(this.currentCategory.id)
    this.priceForm.controls.category_name.setValue(this.currentCategory.name)

    if (this.priceForm.valid) {

      let price: AnnuityPrice = new AnnuityPrice()
      price.lot_id = this.priceForm.controls.lot_id.value
      price.category_id = this.priceForm.controls.category_id.value
      price.category_name = this.priceForm.controls.category_name.value

      price.value = Number(this.priceForm.controls.value.value)

      //console.log("productPriceAded: " + JSON.stringify(price))
      this._annuityPriceService.insert(price);

    }
  }

}
